// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200..1000;1,200..1000&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
General
*/
:root {
  scroll-behavior: smooth;
  --primary: #4154f1;
  --second: #717ff5;
  --bgColor: #f6f9ff;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Open Sans", sans-serif;
  color: #444444;
  background: var(--bgColor);
}

a {
  color: var(--primary);
  text-decoration: none;
  cursor: pointer;
}

a:hover {
  color: var(--second);
  text-decoration: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Nunito", sans-serif;
}

/**
Override some default Bootstrap stylings
*/

/* Dropdown menus */
.dropdown-menu {
  border-radius: 4px;
  padding: 10px 0;
  animation-name: dropdown-animate;
  animation-duration: 0.2s;
  animation-fill-mode: both;
  border: 0;
  box-shadow: 0 5px 30px 0 rgba(82, 63, 105, 0.2);
}

.dropdown-menu .dropdown-header,
.dropdown-menu .dropdown-footer {
  text-align: center;
  font-size: 15px;
  padding: 10 px 25px;
}

.dropdown-menu .dropdown-footer a {
  color: #444444;
  text-decoration: underline;
}

.dropdown-menu .dropdown-footer a:hover {
  text-decoration: none;
}

.dropdown-menu .dropdown-divider {
  color: #a5c5fe;
  margin: 0;
}

.dropdown-menu .dropdown-item {
  font-size: 14px;
  padding: 10px 15px;
  transition: 0.3s;
}

.dropdown-menu .dropdown-item i {
  margin-right: 10px;
  font-size: 18px;
  line-height: 0;
}

.dropdown-menu .dropdown-item:hover {
  background-color: #f6f9ff;
}

@media (min-width: 768px) {
  .dropdown-menu-arrow::before {
    content: "";
    width: 13px;
    height: 13px;
    background: #fff;
    position: absolute;
    top: -7px;
    right: 20px;
    transform: rotate(45deg);
    border-top: 1px solid #eaedf1;
    border-left: 1px solid #eaedf1;
  }
}

@keyframes dropdown-animate {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }

  0% {
    opacity: 0;
  }
}

.card1 {
  margin-bottom: 30px;
  border: none;
  border-radius: 5px;
  box-shadow: 0px 0 30px rgba(1, 41, 112, 0.1);
}

.card-header1,
.card-footer1 {
  border-color: #ebeef4;
  background-color: #fff;
  color: #798eb3;
  padding: 15px;
}

.card-title {
  padding: 20px 0 15px 0;
  font-size: 18px;
  font-weight: 500;
  color: #012970;
  letter-spacing: 1px;
  font-family: "Roboto", sans-serif;
}

.card-title span {
  color: #899bbd;
  font-size: 14px;
  font-weight: 400;
}

.card-body {
  padding: 0 20px 20px 20px;
}

.card-img-overlay {
  background-color: rgba(255, 255, 255, 0.6);
}

.card-body button {
  margin: 0 0 0 20px;
}

.card-body button div {
  gap: 5px;
  display: flex;
  align-items: center;
}

.btn-group1 {
  /*overflow-x: auto;*/
}

.DocSearch-Hit-action {
  align-items: center;
  display: flex;
  height: 22px;
  width: 22px;
}
.DocSearch-Hit-action svg {
  display: block;
  height: 18px;
  width: 18px;
}
.DocSearch-Hit-action + .DocSearch-Hit-action {
  margin-left: 6px;
}
.DocSearch-Hit-action-button {
  appearance: none;
  background: none;
  border: 0;
  border-radius: 50%;
  color: inherit;
  cursor: pointer;
  padding: 2px;
}
svg.DocSearch-Hit-Select-Icon {
  display: none;
}
.DocSearch-Hit[aria-selected="true"] .DocSearch-Hit-Select-Icon {
  display: block;
}
.DocSearch-Hit-action-button:focus,
.DocSearch-Hit-action-button:hover {
  background: #666;
  transition: background-color 0.1s ease-in;
}
@media screen and (prefers-reduced-motion: reduce) {
  .DocSearch-Hit-action-button:focus,
  .DocSearch-Hit-action-button:hover {
    transition: none;
  }
}
.DocSearch-Hit-action-button:focus path,
.DocSearch-Hit-action-button:hover path {
  fill: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;;CAEC;AACD;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;;;;;EAME,iCAAiC;AACnC;;AAEA;;CAEC;;AAED,mBAAmB;AACnB;EACE,kBAAkB;EAClB,eAAe;EAEf,gCAAgC;EAEhC,wBAAwB;EAExB,yBAAyB;EACzB,SAAS;EACT,+CAA+C;AACjD;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,wBAAwB;IACxB,6BAA6B;IAC7B,8BAA8B;EAChC;AACF;;AAeA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,WAAW;AACb;AACA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EAGE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;;EAEE,gBAAgB;EAChB,yCAAyC;AAC3C;AACA;EACE;;IAEE,gBAAgB;EAClB;AACF;AACA;;EAEE,UAAU;AACZ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200..1000;1,200..1000&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap\");\n\n/**\nGeneral\n*/\n:root {\n  scroll-behavior: smooth;\n  --primary: #4154f1;\n  --second: #717ff5;\n  --bgColor: #f6f9ff;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: \"Open Sans\", sans-serif;\n  color: #444444;\n  background: var(--bgColor);\n}\n\na {\n  color: var(--primary);\n  text-decoration: none;\n  cursor: pointer;\n}\n\na:hover {\n  color: var(--second);\n  text-decoration: none;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Nunito\", sans-serif;\n}\n\n/**\nOverride some default Bootstrap stylings\n*/\n\n/* Dropdown menus */\n.dropdown-menu {\n  border-radius: 4px;\n  padding: 10px 0;\n  -webkit-animation-name: dropdown-animate;\n  animation-name: dropdown-animate;\n  -webkit-animation-duration: 0.2s;\n  animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  border: 0;\n  box-shadow: 0 5px 30px 0 rgba(82, 63, 105, 0.2);\n}\n\n.dropdown-menu .dropdown-header,\n.dropdown-menu .dropdown-footer {\n  text-align: center;\n  font-size: 15px;\n  padding: 10 px 25px;\n}\n\n.dropdown-menu .dropdown-footer a {\n  color: #444444;\n  text-decoration: underline;\n}\n\n.dropdown-menu .dropdown-footer a:hover {\n  text-decoration: none;\n}\n\n.dropdown-menu .dropdown-divider {\n  color: #a5c5fe;\n  margin: 0;\n}\n\n.dropdown-menu .dropdown-item {\n  font-size: 14px;\n  padding: 10px 15px;\n  transition: 0.3s;\n}\n\n.dropdown-menu .dropdown-item i {\n  margin-right: 10px;\n  font-size: 18px;\n  line-height: 0;\n}\n\n.dropdown-menu .dropdown-item:hover {\n  background-color: #f6f9ff;\n}\n\n@media (min-width: 768px) {\n  .dropdown-menu-arrow::before {\n    content: \"\";\n    width: 13px;\n    height: 13px;\n    background: #fff;\n    position: absolute;\n    top: -7px;\n    right: 20px;\n    transform: rotate(45deg);\n    border-top: 1px solid #eaedf1;\n    border-left: 1px solid #eaedf1;\n  }\n}\n\n@-webkit-keyframes dropdown-animate {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n\n  0% {\n    opacity: 0;\n  }\n}\n\n@keyframes dropdown-animate {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n\n  0% {\n    opacity: 0;\n  }\n}\n\n.card1 {\n  margin-bottom: 30px;\n  border: none;\n  border-radius: 5px;\n  box-shadow: 0px 0 30px rgba(1, 41, 112, 0.1);\n}\n\n.card-header1,\n.card-footer1 {\n  border-color: #ebeef4;\n  background-color: #fff;\n  color: #798eb3;\n  padding: 15px;\n}\n\n.card-title {\n  padding: 20px 0 15px 0;\n  font-size: 18px;\n  font-weight: 500;\n  color: #012970;\n  letter-spacing: 1px;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.card-title span {\n  color: #899bbd;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.card-body {\n  padding: 0 20px 20px 20px;\n}\n\n.card-img-overlay {\n  background-color: rgba(255, 255, 255, 0.6);\n}\n\n.card-body button {\n  margin: 0 0 0 20px;\n}\n\n.card-body button div {\n  gap: 5px;\n  display: flex;\n  align-items: center;\n}\n\n.btn-group1 {\n  /*overflow-x: auto;*/\n}\n\n.DocSearch-Hit-action {\n  align-items: center;\n  display: flex;\n  height: 22px;\n  width: 22px;\n}\n.DocSearch-Hit-action svg {\n  display: block;\n  height: 18px;\n  width: 18px;\n}\n.DocSearch-Hit-action + .DocSearch-Hit-action {\n  margin-left: 6px;\n}\n.DocSearch-Hit-action-button {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background: none;\n  border: 0;\n  border-radius: 50%;\n  color: inherit;\n  cursor: pointer;\n  padding: 2px;\n}\nsvg.DocSearch-Hit-Select-Icon {\n  display: none;\n}\n.DocSearch-Hit[aria-selected=\"true\"] .DocSearch-Hit-Select-Icon {\n  display: block;\n}\n.DocSearch-Hit-action-button:focus,\n.DocSearch-Hit-action-button:hover {\n  background: #666;\n  transition: background-color 0.1s ease-in;\n}\n@media screen and (prefers-reduced-motion: reduce) {\n  .DocSearch-Hit-action-button:focus,\n  .DocSearch-Hit-action-button:hover {\n    transition: none;\n  }\n}\n.DocSearch-Hit-action-button:focus path,\n.DocSearch-Hit-action-button:hover path {\n  fill: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
